import React from 'react';
import { ComplianceSection } from '@fiverr-private/compliance';
import { useAgencySellerData } from '../../hooks/useAgencySellerData';
import { AgencySeller } from '../../types';

export const ComplianceArea = ({ sellerId }: { sellerId: number }) => {
    const { username } = useAgencySellerData(selectSellerSlice);

    return <ComplianceSection requeseteeId={sellerId} requeseteeUserName={username} />;
};

const selectSellerSlice = ({ user: { name } }: AgencySeller) => ({
    username: name,
});
